import BlockIcon from '@mui/icons-material/Block'

import { useState } from 'react'

import { Box, Flex, FloraTag, FloraTypography } from '@grupoboticario/flora-react'

import Header from '@/components/Header/Header'
import HeaderDetails from '@/components/Header/HeaderDetails'
import { HomologationTag } from '@/components/HomologationTag/HomologationTag'
import Menu from '@/components/Menu/Menu'
import { useHeaderContext } from '@/context/header'
import { FadeIn } from '@/utils/useFadeIn/useFadeIn'

import * as S from './Layout.styles'

const Layout = ({ children, title }) => {
  const [toggleMenu, setToggleMenu] = useState(false)
  const {
    memberStatus: { isBlocked }
  } = useHeaderContext()

  return (
    <FadeIn>
      <Flex css={S.containerStyle}>
        <Box css={S.menuContainerStyle}>
          <Header css={S.headerStyle} onToggleSideMenu={setToggleMenu} openMenu={toggleMenu} />
          <Menu onToggleSideMenu={setToggleMenu} openMenu={toggleMenu} />
        </Box>
        <Flex css={S.fullWidthCss} justify="center">
          <Box css={S.contentStyle}>
            <HeaderDetails />
            {title && (
              <Flex css={S.titleContainerStyle}>
                <FloraTypography as="h1" fontSize="heading" viewport="desktop">
                  {title}
                </FloraTypography>
                <Flex align="center" css={S.tagsContainerStyle} gap="$2">
                  <HomologationTag />
                  {!!isBlocked && (
                    <FloraTag css={S.tagCss} leftIcon={<BlockIcon />} styleSemantic="error" type="readOnly">
                      Bloqueado
                    </FloraTag>
                  )}
                </Flex>
              </Flex>
            )}
            <Box>{children}</Box>
          </Box>
        </Flex>
      </Flex>
    </FadeIn>
  )
}

export { Layout }
